<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file BaseModal.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  BaseModal.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div :id="id"
         class="modal show fade"
         tabindex="-1"
         role="dialog"
    >
        <div class="modal-dialog modal-dialog-centered"
             role="document"
        >
            <div v-if="display === true"
                 class="modal-content">
                <header class="modal-header"
                        :class="{
                    'bg-primary':!confirmed,
                    'bg-success':confirmed
                    }">
                    <h3>
                        <slot name="header"></slot>
                    </h3>
                </header>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <footer class="modal-footer py-0">
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "BaseModal",
        props: {
            id: {
                type: String,
                default: 'vue-ticket--modal'
            },
            display: {
                type: Boolean,
                default: false
            },
            confirmed: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            if (self.display === true) {
                self.show(true)
            }

        },
        methods: {
            show(show) {
                let self = this,
                    identifier = '#' + self.id;

// console.log('show triggered value',show);


                $(identifier)
                    .modal(show === true?'show':'hide')
                    .on('hidden.bs.modal', function (e) {
                        // console.log('modal closing');
                        self.$emit('modal_close',true)
                    });
            }
        },
        watch: {
            display(show, old) {
                // console.log('show',show, 'old',old)
                if (old !== show) {
                    this.show(show);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseModal.vue